import type {FeatureAppDefinition, FeatureServices} from '@feature-hub/core';
import type {ReactFeatureApp} from '@feature-hub/react';
import type {
  LayerManagerV2,
  LayerManagerV24,
} from '@volkswagen-onehub/layer-manager';
import * as React from 'react';

import {LayerManagerComponent} from './layer-manager-component';

export interface LayersFeatureAppDependencies extends FeatureServices {
  readonly 'layer-manager': LayerManagerV2 | LayerManagerV24;
}

export type LayersFeatureAppConfig = {};

const featureAppDefinition: FeatureAppDefinition<
  ReactFeatureApp,
  LayersFeatureAppDependencies
> = {
  dependencies: {
    featureServices: {
      'layer-manager': '^2.7.2',
    },
  },

  create: ({featureServices}) => {
    const layerManager = featureServices['layer-manager'];

    return {
      render: () => <LayerManagerComponent layerManager={layerManager} />,
    };
  },
};

export default featureAppDefinition;
